import { useCallback } from 'react';
import i18next from 'i18next';
import { currentMarkSurface } from 'src/components/Chat/Chat.humanAction';
import type { tMarkSurface } from 'src/components/Chat/Chat.types';
import { useAnalytics } from '../useAnalytics.hook';
import {
  UNDELIVERED_EVENTS,
  tUndeliveredFilterLevel,
} from './undeliveredAnalytics.constants';

type tFilterUsed = {
  surface: tMarkSurface;
  level: tUndeliveredFilterLevel;
  /** The count the control already loaded; null while it has not. */
  resultCount: number | null;
};

/** INT-1602: the two undelivered-mark events the web app emits. */
export function useUndeliveredAnalytics() {
  const { trackEvent } = useAnalytics();

  /**
   * Call when a filter turns ON. Emits nothing while the count has not loaded:
   * an event that stamps a count must never carry one that is not there yet.
   */
  const trackFilterUsed = useCallback(
    ({ surface, level, resultCount }: tFilterUsed) => {
      if (resultCount === null) return;
      trackEvent(UNDELIVERED_EVENTS.FILTER_USED, {
        surface,
        level,
        result_count: resultCount,
      });
    },
    [trackEvent],
  );

  /** Call when "Cómo resolverlo" opens on a notice. */
  const trackNoticeOpened = useCallback(
    (errorCode: string | number | null | undefined) => {
      trackEvent(UNDELIVERED_EVENTS.NOTICE_OPENED, {
        surface: currentMarkSurface() ?? null,
        error_code: errorCode ?? null,
        // Read at the moment it opens: the language the person sees then.
        locale: i18next.language ?? null,
      });
    },
    [trackEvent],
  );

  return { trackFilterUsed, trackNoticeOpened };
}
